import {
  CampaignTemplate,
  CreateReconAiCampaignRequest,
  GenerateReconAiCampaignTemplate,
} from '@/client/campaigns/types';
import { getExceptionFromAxiosError } from '@/client/helpers';
import { MessageResponseModel } from '@/client/models';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

export const reconAiService = (client: AxiosInstance) => {
  const RECON_AI_BASE_URL = (accountId: string) =>
    `/accounts/${accountId}/campaigns/recon-ai`;

  const createReconAiCampaign = async (
    accountId: string,
    params: CreateReconAiCampaignRequest,
  ): Promise<MessageResponseModel> => {
    try {
      const result = await client.post<
        MessageResponseModel,
        AxiosResponse<MessageResponseModel>
      >(RECON_AI_BASE_URL(accountId), params, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const generateReconAiCampaignTemplate = async (
    accountId: string,
    params: GenerateReconAiCampaignTemplate,
  ): Promise<CampaignTemplate> => {
    try {
      const result = await client.post<
        CampaignTemplate,
        AxiosResponse<CampaignTemplate>
      >(`${RECON_AI_BASE_URL(accountId)}/generate-campaign-template`, params, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const reconAiCampaignNotifyUrl = (accountId: string) =>
    `${client.defaults.baseURL}accounts/${accountId}/campaigns/recon-ai/notify`;

  return {
    createReconAiCampaign,
    generateReconAiCampaignTemplate,
    reconAiCampaignNotifyUrl,
  };
};
